<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{Label | localize}}</mat-label>

  <mat-chip-grid #chipGrid>

    <mat-chip-row
      *ngFor="let tag of selectedTags"
      (removed)="removeTag(tag)"
    >
      {{ tag }}

      <button matChipRemove>
        ✕
      </button>
    </mat-chip-row>

    <input
    *ngIf="selectedTags.length < MexTagCount"
      #tagInput
      [formControl]="tagCtrl"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="addTag($event)"
      placeholder="Type or select ..."
    />

  </mat-chip-grid>

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selected($event.option.value)"
  >
    <mat-option
      *ngFor="let tag of filteredTags | async"
      [value]="tag"
    >
      {{ tag }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
